export default __webpack_public_path__ + "static/media/cart2hover.09d930cf.jpg";